import { render, staticRenderFns } from "./EmployerUpdateServiceLogModal.vue?vue&type=template&id=1399e820&scoped=true&"
import script from "./EmployerUpdateServiceLogModal.vue?vue&type=script&lang=ts&"
export * from "./EmployerUpdateServiceLogModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1399e820",
  null
  
)

export default component.exports